import { useMemo } from 'react'
import { getFilteredMentionSuggestions } from '@/components/AiAskBar/mentionSuggestions'

export function useComposerMentionSuggestions(mentionMembers, mentionAgents, mentionTrigger, mentionFlatCountRef) {
  const { users: mentionUsers, agents: mentionAgentsList } = useMemo(
    () =>
      getFilteredMentionSuggestions({
        members: mentionMembers,
        agents: mentionAgents,
        query: mentionTrigger?.query ?? '',
      }),
    [mentionMembers, mentionAgents, mentionTrigger?.query],
  )

  const mentionFlatCount = mentionUsers.length + mentionAgentsList.length
  mentionFlatCountRef.current = mentionFlatCount

  return { mentionUsers, mentionAgentsList, mentionFlatCount }
}
